module.exports = __webpack_public_path__ + "img/logo_mini.e63666a4.svg";